<template>
  <div class="row">
    <div class="col-12">
      <block-header :overline="header.overline" :title="header.title" :subtitle="header.subTitle" />
      <figure class="w-100">
        <b-img :src="image" fluid alt="" />
        <figcaption class="caption" v-if="caption">{{ caption }}</figcaption>
      </figure>

      <vue-markdown :source="description" />
    </div>
  </div>
</template>

<script>
import BlockHeader from "../../../molecules/BlockHeader";
import VueMarkdown from "vue-markdown";

export default {
  name: "Infographic",
  components: { BlockHeader, VueMarkdown },
  props: {
    header: Object,
    description: String,
    image: String,
    caption: String,
  },
};
</script>

<style scoped lang="scss">
.caption {
  text-align: center;
  font-style: italic;
  color: rgba($color-dark, 0.7);
}
</style>
